













































































































































import Vue from 'vue';
import Customer from '../../../../customer/models/Customer';
import {
  WxSubTpl,
  ScheduleMsgParam,
  ScheduleMsgCoupon,
  transDiv,
  transValue } from '../../../models/ScheduleMsg';
import { MustValueProps, ExcludeProps } from '../../../models/FieldType';
import scheduleRuleVuex from '../../../vuex/common';
import ScheduleMsgPreview from './ScheduleMsgPreview.vue';
import MessageBox from '../../../../mass/components/common/MessageBox.vue';
import massApis from '@/mass/apis';
import EditDiv from './EditDiv.vue';
import SetProp from './SetProp.vue';
import CouponBox from '@/mass/components/common/CouponBox.vue';
import { SubTpl, formatTip, errMsg } from '@/mass/models/SubTpl';

function dripProp(name: string): string {
  return `<drip-prop contenteditable="false">#${name}</drip-prop>`;
}

enum RedirectType {
  Link = 1,
  Mini = 2,
  Coupon = 3,
  Neither = 0,
}

const tplPropConfigs: { [key: string]: any[] } = {};
const redirectType: RedirectType = RedirectType.Link as RedirectType
const tplValues: { [key: string]: string } = {}

function guid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
}

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    ScheduleMsgPreview,
    MessageBox,
    EditDiv,
    SetProp,
    CouponBox,
  },
  props: {
    msg: {
      type: Object as () => WxSubTpl | null,
    },
    tpl: {
      type: Object as () => SubTpl,
      required: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formatTip,
      code: guid(),
      editField: null,
      scene: 'activity',
      showCouponBox: false,
      showPreview: false,
      hackId: 0,
      prop: null,
      visable: false,
      redirectType,
      couponInfo: null,
      MustValueProps,
      ExcludeProps,
      tplValues,
      tplPropConfigs,
      RedirectType,
      remarkOpen: false,
      remark: null,
      redirectUrl: null,
      miniAppid: null,
      miniPagePath: null,
    };
  },
  computed: {
    wxTplFields(): [string, string][] {
      return this.tpl.params
    },
    optionProps(): any[] {
      return this.props.filter((r: any) => !this.MustValueProps.find((m: any) => m.fieldName === r.fieldName) && !this.ExcludeProps.find((m: any) => m.fieldName === r.fieldName));
    },
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        p.propName = '<drip-prop contenteditable="false">#' + p.propName + '</drip-prop>';
        return p;
      });
    },
    tranTextProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        if (p.builtIn) {
          p.fieldName = '\\${' + p.fieldName + '}';
        } else {
          p.fieldName = '\\${privateProps.' + p.fieldName + '}';
        }
        return p;
      });
    },
  },
  methods: {
    confirmSelectCoupon(res: any) {
      this.showCouponBox = false;
      this.couponInfo = {
        id: res.id,
        cardId: res.cardId,
        color: res.baseInfo.color,
        title: res.baseInfo.title,
        brandName: res.baseInfo.brandName,
        logoUrl: res.baseInfo.logoUrl,
      }
    },
    addProp() {
      this.visable = false;
    },
    checkProp(name: string) {
      this.editField = name.split('^')[0];
      const fieldName = name.split('^')[1];
      const prop = this.props.find((r: any) => r.fieldName === fieldName);
      if (this.tplValues[this.editField] && prop && this.tplValues[this.editField].indexOf(dripProp(prop.propName)) > -1) {
        this.$Message.warning('同一字段只能设置一次');
        return;
      }
      if (this.MustValueProps.find((r: any) => r.fieldName === fieldName)) {
        const propText = dripProp(prop.propName)
        if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('<br></div>')) {
          this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 10) + propText + '</div>';
        } else if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('</div>')) {
          this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 6) + propText + '</div>';
        } else {
          this.tplValues[this.editField] = (this.tplValues[this.editField] ? this.tplValues[this.editField] : '')  + propText;
        }
        this.tplValues = JSON.parse(JSON.stringify(this.tplValues));
        if (!this.tplPropConfigs[this.editField]) {
          this.tplPropConfigs[this.editField] = [];
        }
        this.tplPropConfigs[this.editField].push({MustProp: {fieldName: fieldName}});
      } else if (fieldName === 'custom.current') {
        if (this.tplValues[this.editField] && this.tplValues[this.editField].indexOf(dripProp('系统时间')) > -1) {
          this.$Message.warning('同一字段只能设置一次');
        } else {
          const propText = dripProp('系统时间');
          if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('<br></div>')) {
            this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 10) + propText + '</div>';
          } else if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('</div>')) {
            this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 6) + propText + '</div>';
          } else {
            this.tplValues[this.editField] = (this.tplValues[this.editField] ? this.tplValues[this.editField] : '')  + propText;
          }
          this.tplValues = JSON.parse(JSON.stringify(this.tplValues));
          if (!this.tplPropConfigs[this.editField]) {
            this.tplPropConfigs[this.editField] = [];
          }
          this.tplPropConfigs[this.editField].push({ExtendProp: {fieldName: fieldName}});
        }
      } else {
        this.prop = prop;
        this.visable = true;
      }
    },
    setProp(data: any) {
      const propText = dripProp(data.prop.propName)
      if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('<br></div>')) {
        this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 10) + propText + '</div>';
      } else if (this.tplValues[this.editField] && this.tplValues[this.editField].endsWith('</div>')) {
        this.tplValues[this.editField] = this.tplValues[this.editField].substring(0, this.tplValues[this.editField].length - 6) + propText + '</div>';
      } else {
        this.tplValues[this.editField] = (this.tplValues[this.editField] ? this.tplValues[this.editField] : '')  + propText;
      }
      this.tplValues = JSON.parse(JSON.stringify(this.tplValues));
      if (!this.tplPropConfigs[this.editField]) {
        this.tplPropConfigs[this.editField] = [];
      }
      if (data.prop.builtIn) {
        if (this.tplPropConfigs[this.editField].find((r) => r && r.OptionProp && r.OptionProp.fieldName === data.prop.fieldName)) {
          const index = this.tplPropConfigs[this.editField].findIndex((r: any) => r.OptionProp && r.OptionProp.fieldName === data.prop.fieldName);
          this.tplPropConfigs[this.editField][index] = {OptionProp: {fieldName: data.prop.fieldName, defaultValue: data.defaultValue}};
        } else {
          this.tplPropConfigs[this.editField].push({OptionProp: {fieldName: data.prop.fieldName, defaultValue: data.defaultValue}});
        }
      } else {
        if (this.tplPropConfigs[this.editField].find((r) => r && r.OptionProp && r.OptionProp.fieldName === 'privateProps.' + data.prop.fieldName)) {
          const index = this.tplPropConfigs[this.editField].findIndex((r: any) => r.OptionProp && r.OptionProp.fieldName === data.prop.fieldName);
          this.tplPropConfigs[this.editField][index] = {OptionProp: {fieldName: 'privateProps.' + data.prop.fieldName, defaultValue: data.defaultValue}};
        } else {
          this.tplPropConfigs[this.editField].push({OptionProp: {fieldName: 'privateProps.' + data.prop.fieldName, defaultValue: data.defaultValue}});
        }
      }
      this.visable = false;
    },
    transValueText(value: string) {
      this.tranTextProps.forEach((p: any) => {
        value = value.replace(new RegExp(p.fieldName, 'g'), dripProp(p.propName));
        value = value.replace(new RegExp('\\${custom.current}', 'g'), dripProp('系统时间'));
      });
      return value;
    },

    validateWxTplSettings(): boolean {
      const values = Object.values(this.tplValues);
      if (values.length < this.wxTplFields.length ||
          values.some((r) => !r || (r as string).trim() === '')) {
        this.$Message.warning('请填写完整的模板字段信息');
        return false;
      } else if (this.redirectType === RedirectType.Link) {
        if (!this.redirectUrl || this.redirectUrl.trim() === '') {
          this.$Message.warning('请填写跳转链接');
          return false;
        }
        if (this.remarkOpen && (!this.remark || this.remark.trim() === '')) {
          this.$Message.warning('请填写标签');
          return false;
        }
        return true;
      } else if (this.redirectType === RedirectType.Mini &&
                 (!this.miniAppid ||
                  this.miniAppid.trim() === '' ||
                  !this.miniPagePath ||
                  this.miniPagePath.trim() === '')) {
        this.$Message.warning('请填写完整的跳转小程序信息');
        return false;
      } else if (this.redirectType === RedirectType.Coupon && !this.couponInfo) {
        this.$Message.warning('请选择优惠券');
        return false;
      } else {
        return true;
      }
    },
    validateParams() {
      const hasError = false
      Object.entries(this.tplValues).forEach(([k, v]) => {

      })
    },
    confirmWxTplSettings() {
      if (this.validateWxTplSettings()) {
        const tpl = this.formatWxSubTpl()
        this.$emit('confirmed', {tpl: tpl, hasError: false});
      } else {
        this.$emit('confirmed', {hasError: true})
      }
    },
    formatWxSubTpl(): WxSubTpl {
      const tpl: Partial<WxSubTpl> = {
        title: this.tpl.title,
        templateId: this.tpl.tplId,
        params: this.normalizeParams(this.formatParams()),
      };
      if (this.redirectType === RedirectType.Link) {
        tpl.url = this.redirectUrl;
        if (this.remarkOpen) {
          tpl.remark = {
            open: true,
            remark: this.remark,
            code: this.code,
          };
        }
      }
      if (this.redirectType === RedirectType.Mini) {
        tpl.mini = {
          appid: this.miniAppid,
          pagepath: this.miniPagePath,
        };
      }
      if (this.redirectType === RedirectType.Coupon) {
        tpl.coupon = this.couponInfo as ScheduleMsgCoupon;
      }
      return JSON.parse(JSON.stringify(tpl));
    },
    doShowPreview() {
      if (this.validateWxTplSettings()) {
        this.showPreview = true;
      }
    },
    setTplValues() {
      if (this.scheduleRule.scheduleMsg) {
        this.tplValues = (this.scheduleRule.scheduleMsg as any).params;
      }
    },
    formatParams(): { [key: string]: ScheduleMsgParam } {
      const params: { [key: string]: ScheduleMsgParam } = {};
      for (const field in this.tplValues) {
        params[field] = {
          value: this.$data.tplValues[field],
          propConfigs: this.tplPropConfigs[field],
        } as ScheduleMsgParam;
      }
      return params;
    },
    normalizeParams(p: {[k: string]: ScheduleMsgParam}) {
      const r: {[k: string]: ScheduleMsgParam} = {}
      const ps = Object.keys(p)
      ps.forEach(k => {
        p[k].value = transDiv(transValue(this.tranProps, p[k].value))
        r[k] = p[k]
      })
      return r
    },
    doPreview(customer: Customer) {
      const tempTpl = JSON.parse(JSON.stringify(this.formatWxSubTpl()));
      if (tempTpl) {
        const keys = Object.keys(tempTpl.params);
        keys.forEach((i: any) => {
          tempTpl.params[i].value = transDiv(transValue(this.tranProps, tempTpl.params[i].value));
        });
      }
      massApis.previewSubTpl({
        openid: customer.openid,
        msg: tempTpl,
      }).success((r) => {
        if (r.msg) {
          this.$Message.error(r.msg);
          this.showPreview = false;
        } else {
          this.$Message.success('发送预览成功，请在手机端查收');
          this.showPreview = false;
        }
      }).failure((code: string, msg?: string) => {
        const init: {[k: string]: string} = {}
        const map = this.wxTplFields.reduce((r, kv) => {
          r[kv[1]] = kv[0]
          return r
        }, init)
        const txt = errMsg(code, msg, map)
        this.$Message.error(txt);
        this.showPreview = false;
      }).error((e) => {
        this.$Message.error(e.toString());
        this.showPreview = false;
      });
    },
    selectText(val: string) {
      this.unsubNotifyReply = val;
    },
  },
  mounted() {
    window.addEventListener('click', (event: any) => {
      if (event.target.className.indexOf('ivu-dropdown-item') === -1) {
        this.visable = false;
      }
    });
  },
});
